'use client';

import { initKyHttp } from './api';
import { setupZeusInterceptors } from './setup';
import { useCommonAuthProvider } from '@modules/auth/providers/CommonAuthProvider/CommonAuthProvider';

import React, { FC, useEffect, useRef } from 'react';

/**
 * Bridges the CommonAuthProvider context into the shared Zeus ky client.
 *
 * Must be placed inside CommonAuthProvider in the component tree. Registers
 * auth once (via the empty-deps effect) while keeping auth functions always
 * current through a ref updated on each render.
 */
export const ZeusClientSetupProvider: FC<React.PropsWithChildren> = ({ children }) => {
  const { getAccessToken, loginWithRedirect } = useCommonAuthProvider();

  const authRef = useRef({ getAccessToken, loginWithRedirect });

  // Keep ref current on every render so hooks always call the latest auth functions.
  useEffect(() => {
    authRef.current = { getAccessToken, loginWithRedirect };
  }, [getAccessToken, loginWithRedirect]);

  useEffect(() => {
    const cleanup = setupZeusInterceptors(authRef);
    initKyHttp();

    return cleanup;
  }, []);

  return children;
};
